import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxRolesService, NgxPermissionsService } from 'ngx-permissions';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../../shared/models/user.model';
import { Token } from '../../shared/models/token.model';

import { environment } from '../../../environments/environment';
import { BusinessAccount } from 'src/app/shared/models/business-account.model';

@Injectable({
	providedIn: 'root'
})

export class profileService {
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;


	constructor(
		public router: Router,
		private http: HttpClient,
		public toastrService: ToastrService,
		public translate: TranslateService,
		public ngxRolesService: NgxRolesService,
		public ngxPermissionsService: NgxPermissionsService
	) { }


	getGalleryByBusinessId(id: any) {
		return this.http.get(`${this.apiUrl1}/api/business-gallery/${id}`);

	}

	getProfileDetails(slug: any) {
		return this.http.get(`${this.apiUrl1}/api/profile/${slug}`)
	}

	insertShopGallery(shopGallery: any) {
		return this.http.post(`${this.apiUrl1}/api/business-gallery`, shopGallery);
	}

	createPage(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/pages`, payload);
	}

	getpages(PagesForId: number) {
		return this.http.get(`${this.apiUrl1}/api/pages/PagesFor/${PagesForId}`)
	}

	getBranches(businessId: number) {
		return this.http.get(`${this.apiUrl1}/api/branches/business-account/${businessId}`)
	}

	postBranches(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/branches`, payload)
	}

	updateBranches(payload: any, id: number) {
		return this.http.put(`${this.apiUrl1}/api/branches/${id}`, payload)
	}

	deleteBranches(id: number) {
		return this.http.delete(`${this.apiUrl1}/api/branches/${id}`)
	}

	postLocations(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/locations`, payload)
	}

	getBusinessAccount() {
		return this.http.get(`${this.apiUrl1}/api/business-account`)
	}

	getLocation(occupiedBy: number) {
		return this.http.get(`${this.apiUrl1}/api/locations/occupied-by/${occupiedBy}`)
	}

	uploadAggrement(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/aggrement`, payload)
	}

	PostServcices(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/services`, payload)
	}

	deleteServcices(id: any) {
		return this.http.delete(`${this.apiUrl1}/api/services/${id}`)
	}

	updateServcices(id: any, payload: any) {
		return this.http.put(`${this.apiUrl1}/api/services/${id}`, payload)
	}

	getServiceBusinessAccount(businessAccountId: string) {
		return this.http.get(`${this.apiUrl1}/api/services/business-account/${businessAccountId}`)
	}

	getService(serviceFor: string, serviceForId: string) {
		return this.http.get(`${this.apiUrl1}/api/services/by-for/${serviceFor}/${serviceForId}`)
	}

	BusninessNetwork(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/businessnetwork`, payload)
	}

	BusninessNetworkWithFiles(formData: FormData): Observable<any> {
		// If same endpoint accepts multipart, reuse baseUrl
		return this.http.post(this.apiUrl1, formData);
	}

	postBrand(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/brands`, payload)
	}

	deleteBrand(id: number) {
		return this.http.delete(`${this.apiUrl1}/api/brands/${id}`)
	}

	UpdateBrand(payload: any, id: number) {
		return this.http.put(`${this.apiUrl1}/api/brands/${id}`, payload)
	}
	getBrandBusinessAccount(businessAccountId: any) {
		return this.http.get(`${this.apiUrl1}/api/brands/business-account/${businessAccountId}`)
	}
	getBrand() {
		return this.http.get(`${this.apiUrl1}/api/brands`)
	}

	postEmailTemplate(payload: any) {
		return this.http.post(`${this.apiUrl1}/api/email-templates/create`, payload)
	}

	getEmailTemplate() {
		return this.http.get(`${this.apiUrl1}/api/email-templates/all`)
	}

	getEmailTemplateBusinessAccount(bussinessAccountId: any) {
		return this.http.get(`${this.apiUrl1}/api/email-templates/business-account/${bussinessAccountId}`)
	}

	getEmailTemplateId(id: any) {
		return this.http.get(`${this.apiUrl1}/api/email-templates/${id}`)
	}

	updateEmailTemplateId(id: number, payload: any) {
		return this.http.put(`${this.apiUrl1}/api/email-templates/update/${id}`, payload)
	}

	deleteEmailTemplateId(id: any) {
		return this.http.delete(`${this.apiUrl1}/api/email-templates/delete/${id}`)
	}

	getEmailTemplateTags() {
		return this.http.get(`${this.apiUrl1}/api/email-tags/all`)
	}

	JoinMembership(payload: any, businessAccountId: any) {
		return this.http.post(`${this.apiUrl1}/api/business/${businessAccountId}/join/member`, payload)
	}

	JoinDistributor(payload: any, businessAccountId: any) {
		return this.http.post(`${this.apiUrl1}/api/business/${businessAccountId}/join/distributor`, payload)
	}

	WhiteLabelProduct(payload: any, businessAccountId: any) {
		return this.http.post(`${this.apiUrl1}/api/business/${businessAccountId}/join/white-label/product`, payload)
	}

	WhiteLabelBrand(payload: any, businessAccountId: any) {
		return this.http.post(`${this.apiUrl1}/api/business/${businessAccountId}/join/white-label/brand`, payload)
	}
}